import type { ReactNode } from 'react'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
} from '@/components/SplitView/SplitViewSidebarListItem'
import styles from './OCRScopeJobItem.module.css'
import { Checkbox } from '@/components/Checkbox'
import { match } from '@/utils/pattern-match-util'
import { Icon } from '@/components/Icon'
import type { OCRScopeWorkStatusFilterId } from '@/features/jobs/scoping/ocr-scope-work-status'

export interface OCRScopeJobItemProps {
  to: string
  isActive: boolean
  jobName: string
  subtitle: string
  action: ReactNode
}

export function OCRScopeJobItem({
  to,
  isActive,
  jobName,
  subtitle,
  action,
}: OCRScopeJobItemProps) {
  return (
    <SplitViewSidebarListItem to={to} active={isActive} visual={action}>
      <SplitViewSidebarListItemTitle>{jobName}</SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle>
        {subtitle}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
}

export interface OCRScopeJobItemActionProps {
  canManageOCRScopingJobs: boolean
  selectedStatusFilterId: OCRScopeWorkStatusFilterId
  checked: boolean
  onToggleItemForBulkAction: () => unknown
}

export function OCRScopeJobItemAction({
  canManageOCRScopingJobs,
  selectedStatusFilterId,
  checked,
  onToggleItemForBulkAction,
}: OCRScopeJobItemActionProps) {
  return (
    <div className={styles.root}>
      {canManageOCRScopingJobs
        ? match(selectedStatusFilterId, {
            ReadyToSubmit: () => (
              <Checkbox
                checked={checked}
                onChange={onToggleItemForBulkAction}
                muteClickEvent
              />
            ),
            UnderReview: () => (
              <Checkbox
                checked={checked}
                onChange={onToggleItemForBulkAction}
                muteClickEvent
              />
            ),
            ErrorOccurred: () => (
              <Checkbox
                checked={checked}
                onChange={onToggleItemForBulkAction}
                muteClickEvent
              />
            ),
            ScopingInProgress: () => <Icon name={'loader-arrows'} />,
          })
        : match(selectedStatusFilterId, {
            ReadyToSubmit: () => (
              <Checkbox
                checked={checked}
                onChange={onToggleItemForBulkAction}
                muteClickEvent
              />
            ),
            UnderReview: () => <Icon name={'info'} />,
            ErrorOccurred: () => <Icon name={'info'} />,
            ScopingInProgress: () => <Icon name={'loader-arrows'} />,
          })}
    </div>
  )
}
